import { css, Flex, styled } from '@withjoy/joykit';
import { buttonStates } from '@apps/admin/routes/Dashboard/common/commonDasboard.styles';

export const Container = styled(Flex)`
  ${({ theme }) => theme.typography.variants.label2};
  align-items: center;
  background: ${props => props.theme.colors.mono1};
  border-radius: 1.5rem;

  svg {
    height: 1rem;
    width: 1rem;
  }

  & > :last-child {
    border-left: 1px solid ${props => props.theme.colors.gray3};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    ${({ theme }) => theme.typography.variants.body2};
  }
`;

export const Bullet = styled.div<{ isEnabled: boolean }>`
  background-color: ${props => (props.isEnabled ? props.theme.colors.primary6 : props.theme.colors.mono7)};
  border-radius: 50%;
  height: 0.5rem;
  width: 0.5rem;
}
`;

export const Label = styled.span`
  display: none;

  @media (min-width: ${({ theme }) => theme.breakpoints.xs}) {
    display: block;
  }
`;

export const optionBase = css`
  align-items: center;
  display: flex;
  column-gap: 0.5rem;
  padding: 0.375rem 1rem;
  height: 2.5rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    height: 1.875rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    height: 2.25rem;
  }
`;

export const Option = styled.button`
  ${buttonStates};
  ${optionBase};
  border-radius: 1.5rem 0 0 1.5rem;
  padding: 0.375rem 1rem;

  &:last-child {
    border-radius: 1.5rem;
  }
`;

export const VisibilityOption = styled.a`
  ${buttonStates};
  ${optionBase};
  border-radius: 0 1.5rem 1.5rem 0;

  &[href] {
    cursor: pointer;
  }
`;
